import React from 'react';
import person from '../img/person.jpeg';
import '../styles/about.css';

const AboutMe = () => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <div id="ueber-mich" className="about-section container col-xxl-8 px-4 py-5">
      <div className="row flex-lg-row align-items-center g-5 py-5">
        <div className="col-lg-6">
          <img
            src={person}
            className="img-fluid rounded-3 shadow-sm"
            alt="Rechtsanwalt Sergej Vorrat"
            width="600"
            height="450"
            loading="lazy"
          />
        </div>
        <div className="col-lg-6">
          <h2 className="display-6 fw-bold mb-3">
            Ihr Anwalt mit Weitblick und digitalem Fokus
          </h2>
          <p>
            Eine fundierte juristische Ausbildung mit beiden Staatsexamina ist die Basis seiner Arbeit. Bereits früh war es Sergej Vorrat wichtig, über den juristischen Tellerrand zu blicken. Durch Tätigkeiten in Kanzleien und Unternehmen hat er gelernt, Fälle nicht nur rechtlich, sondern auch aus wirtschaftlicher und operativer Sicht zu verstehen.
          </p>
          <p>
            Diese Perspektive prägt ihn bis heute: Er ist nicht nur Ihr Anwalt, sondern Ihr strategischer Berater, der das große Ganze im Blick hat.
          </p>
          
          <p>
            Seine Fähigkeit, interdisziplinär zu denken, hat er in einer internationalen Großkanzlei bei der Arbeit an komplexen Mandaten vertieft.
            </p> 
            
            <p>Dort wurde ihm klar: Die Zukunft der Wirtschaft ist digital. Diese Erkenntnis führte ihn zur gezielten Spezialisierung auf digitale und wirtschaftliche Themen – eine Leidenschaft, die seine Arbeit heute antreibt.
          </p>
          <p>
            Sergej Vorrat verbindet klassische juristische Expertise mit einem Verständnis für digitale Geschäftsmodelle. Sein Ziel ist es, Ihnen komplexe Themen einfach zu erklären und klare Handlungsempfehlungen zu geben – immer direkt und auf Augenhöhe.
          </p>
          <button
            className="btn btn-outline-dark mt-3"
            onClick={() => scrollToSection('kontakt')}
          >
            Kontakt aufnehmen
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
